import React from "react";
import axios from "axios";

import { BACKEND_CONFIG } from "../../config/consts";
import iconPlus from "../../images/icon-plus-circle.svg";
import iconMinus from "../../images/icon-minus-circle.svg";

import { NewAddress } from "./NewAddress";

import "../../styles/collect-payment-page.scss";

export class BillingAddress extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      addresses: [],
      isNew: false,
      frontErrors: null,
      selectedAddress: -1,
    };
  }

  componentDidMount() {
    this.loadAddresses();
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.selectedAddress !== this.state.selectedAddress) {
      this.props.onAddressSelected(
        nextState.addresses[nextState.selectedAddress]
      );
    }
  }

  loadAddresses() {
    axios
      .get(
        BACKEND_CONFIG.apiUrl +
          "collect-payment/billing-addresses?clientId=" +
          this.props.clientId
      )
      .then((data) => {
        var selectedItem = -1;
        if (data.data.length > 0) {
          selectedItem = 0;
        }
        this.setState({ addresses: data.data, selectedAddress: selectedItem });
      });
  }

  addNewAddress(address) {
    var newAddress = {
      Address1: address.address1,
      Address2: address.address2,
      City: address.city,
      State: address.state,
      Zip: address.zip,
    };
    this.setState((prevState) => ({
      selectedAddress: this.state.addresses.length,
      addresses: [...prevState.addresses, newAddress],
      isNew: false,
    }));
  }

  render() {
    return (
      <div>
        <h3>SELECT BILLING ADDRESS</h3>

        {this.state.addresses.map((address, i) => {
          return (
            <div key={i} className="form-group billing-address-item">
              <label
                id={"billing-address-item-label-" + i}
                htmlFor={"billing-address-item-radio-" + i}
              >
                <p>{address.Address1}</p>
                {address.Address2 && <p>{address.Address2}</p>}
                <p>
                  {address.City}, {address.State} {address.Zip}
                </p>
              </label>
              <input
                id={"billing-address-item-radio-" + i}
                name={"billing-address-item-radio-" + i}
                checked={i === this.state.selectedAddress}
                onChange={() => {
                  this.setState({ selectedAddress: i });
                }}
                type="radio"
              />
            </div>
          );
        })}
        <div
          className="add-btn"
          onClick={() => this.setState({ isNew: !this.state.isNew })}
        >
          <span className="plus-minus-button">
            <img
              alt="Add a New Address"
              src={this.state.isNew ? iconMinus : iconPlus}
            />
            Add a New Address
          </span>
        </div>
        {this.state.isNew && (
          <NewAddress
            submitAddress={(adddress) => this.addNewAddress(adddress)}
          />
        )}
      </div>
    );
  }
}
